var _defs, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _rect3, _path6, _polyline, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bda2e863-c1d5-4e00-82f9-63d4ee9c994f",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b7c78d20-3e9a-4443-8fae-b50541040061,.e5b91cb9-d999-4cc4-9970-639b934affd5{fill:none;}.b7c78d20-3e9a-4443-8fae-b50541040061,.f3d0688f-c6c5-4d10-b2b8-e0c12ee11eda{stroke:#8e8e8e;}.a5c83f36-5120-4467-9f2a-eafd91a1d1b7,.b7c78d20-3e9a-4443-8fae-b50541040061,.e5b91cb9-d999-4cc4-9970-639b934affd5,.f3d0688f-c6c5-4d10-b2b8-e0c12ee11eda{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.e0c6ccd8-fae9-42ec-8433-80dde13a2c7c,.f3d0688f-c6c5-4d10-b2b8-e0c12ee11eda{fill:#ea3d3e;}.fce9a594-c88d-4146-b014-ff97748a24dc{fill:#fff;}.a5c83f36-5120-4467-9f2a-eafd91a1d1b7,.e5b91cb9-d999-4cc4-9970-639b934affd5{stroke:#645346;}.a5c83f36-5120-4467-9f2a-eafd91a1d1b7{fill:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b7c78d20-3e9a-4443-8fae-b50541040061",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f3d0688f-c6c5-4d10-b2b8-e0c12ee11eda",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e0c6ccd8-fae9-42ec-8433-80dde13a2c7c",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fce9a594-c88d-4146-b014-ff97748a24dc",
    d: "M49.8,67.6H45.9v3.6h4.3v1.1H44.5V62.2H50v1.1H45.9v3.2h3.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fce9a594-c88d-4146-b014-ff97748a24dc",
    d: "M51.9,62.3h2.5a4.6,4.6,0,0,1,2.9.8,2.9,2.9,0,0,1,.8,2.1,3.2,3.2,0,0,1-.7,2.2,4.5,4.5,0,0,1-3.1,1.1H53.2v4H51.9Zm1.3,4.9h1.1c1.6,0,2.5-.7,2.5-2.1s-.9-2-2.3-2H53.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fce9a594-c88d-4146-b014-ff97748a24dc",
    d: "M59.7,70.7a4.5,4.5,0,0,0,2.4.7c1.3,0,2.1-.7,2.1-1.7s-.6-1.5-1.9-2-2.7-1.5-2.7-2.9,1.3-2.7,3.3-2.7a4.2,4.2,0,0,1,2.2.5l-.4,1a3.6,3.6,0,0,0-1.9-.5,1.7,1.7,0,0,0-1.9,1.6c0,.9.6,1.4,2,1.9s2.6,1.5,2.6,3-1.2,2.9-3.5,2.9a4.7,4.7,0,0,1-2.6-.7Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "e5b91cb9-d999-4cc4-9970-639b934affd5",
    x: 37.2,
    y: 48.9,
    width: 4.6,
    height: 4.58
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e5b91cb9-d999-4cc4-9970-639b934affd5",
    x: 59,
    y: 27.8,
    width: 4.6,
    height: 4.58
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e5b91cb9-d999-4cc4-9970-639b934affd5",
    d: "M39.5,48.9A18.7,18.7,0,0,1,58.2,30.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "e5b91cb9-d999-4cc4-9970-639b934affd5",
    points: "49.7 45 48.4 39.5 53.9 40.8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a5c83f36-5120-4467-9f2a-eafd91a1d1b7",
    x: 42.7,
    y: 33.8,
    width: 4.6,
    height: 4.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEps);
export default __webpack_public_path__ + "static/media/eps.972f5e5d612e4e8357be3ccef9c5a917.svg";
export { ForwardRef as ReactComponent };